import { Stack } from '@mui/material';
import { DriveLogo } from '../logos';
import { Copyright } from './copyright';

export function PublicFooter() {
    return (
        <Stack pt={2} alignSelf='end' justifyContent='space-between' alignItems='center' width='100%' direction='row'>
            <DriveLogo />
            <Copyright />
        </Stack>
    );
}
